<template>
  <div>
    <div class="p-5">
      <textarea class="shadow-md  border border-gray-300 rounded-lg focus:outline-none focus:shadow-outline bg-gray-100 h-32 w-full mb-2 appearance-none resize-none p-3"></textarea>
      <div class="flex justify-end">

        <div  class="cursor-pointer shadow-xl rounded-full pr-6 py-2 text-center bg-gray-300 border-gray-500">
          <img src="../ics/avatar.svg" class="mx-3 mr-1 inline" alt="" />
          Comment
        </div>

      </div>
    </div>

    <div class=" border-gray-500 border-t">
      <CommentOne></CommentOne>
      <CommentOne></CommentOne>
      <CommentOne></CommentOne>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    CommentOne: require('./CommentOne.vue').default
  }
}
</script>

<style>

</style>
